<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Apoio"
                @click.stop="confirmarExcluirApoio()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        apoio: {
            type: Object,
            default: () => ({})
        },

        apoiosServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluirApoio() {
            this.$swal({
                title: 'Excluir Apoio',
                html: `Confirma a exclusão do colaborador da equipe de apoio?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            this.apoiosServicos
                .excluirApoios(this.apoio.apoioId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Colaborador excluído com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterApoiosAtualizados')
                        } else {
                            this.$toast.error(
                                'Erro ao excluir o colaborador',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }

        // registroSalvoComSucesso(data) {
        //     this.$toast.success(
        //         'Registro salvo com sucesso!',
        //         'OK',
        //         this.$toastConfig.success
        //     )
        //     this.$emit('obterDotacoesAtualizadas')
        // }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
